import ElementalPage from '@modules/elemental-page/page/ElementalPage';
import { loader } from '@modules/elemental-page/loaders/elemental-page-loader.server';
import { dynamicLinks } from '@modules/elemental-page/util/get-dynamic-links';
import type { APHandle, HandleHideNavigation } from '@modules/root';

import {
    getCanonicalHreflang,
    createMetaTitle,
    createOGTags,
    createMetaDescription,
    mergeMeta,
} from '~/modules/seo';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data } = props;
        const title = createMetaTitle(props, [
            data?.localisation?.Title,
            'About Us',
        ]);
        const description = createMetaDescription([]);

        const preloadImageLinks = dynamicLinks(props);
        return [
            {
                title,
            },
            { name: 'description', content: description },
            ...createOGTags({
                meta: props,
                title,
                description,
            }),
            ...getCanonicalHreflang(props),
            ...preloadImageLinks,
        ];
    },
);

export { loader };
export default ElementalPage;

const hideTopNavigation: HandleHideNavigation = {
    desktop: true,
    tablet: true,
    mobile: true,
};

export const handle: APHandle = {
    hideTopNavigation,
    disableSearch: true,
    disableTopNavAnimation: false,
};
